import React, { useState } from "react";
import Colors from "../../../stories/assets/Colors";
import {
  HeadingBg,
  TennisSport,
  SoccerSport,
  BaseballSport,
  SkatingSport,
  FootballSport,
  BasketballSport,
  GolfSport,
  logoColor,
  sunIcon1,
  sunIcon2,
  sunIcon3,
  sunIcon4,
  sunIcon5,
  sunIcon6,
  CancelIconBlack,
  LogoShortColor,
  ArrowUpRightBlue,
} from "../../../constant/imagePath";
import { Container, Row, Col } from "react-bootstrap";
import classes from "./StepMobile.module.css";
import { ReactSVG } from "react-svg";
import Fonts from "../../../stories/assets/Fonts";
import { PlayCard } from "../../../stories/PlayCard/PlayCard";
import { Button } from "../../../stories/Button/Button";
import { LinkButtonWithIcon } from "../../../stories/LinkButtonWithIcon/LinkButtonWithIcon";
import { DropDown } from "../../../stories/DropDown/DropDown";
import Maps from "../../../components/Maps";
import { Checkbox } from "../../../stories/Checkbox/Checkbox";
import { useHistory } from "react-router";
import MonthSmallCalander from "../../../components/MonthSmallCalander";

function GetAMatchMobile() {
  const history = useHistory();
  const [selectedValue, setSelectedValue] = useState(null);
  const [pageCount, setPageCount] = useState(1);

  const [progressBar, setProgressBar] = useState(16.66);

  const [coachQualities, setCoachQualities] = useState([]);
  const [unSelectCoachQualities, setUnSelectCoachQualities] = useState();

  const [skillsTaught, setSkillsTaught] = useState([]);
  const [unSelectSkillsTaught, setUnSelectSkillsTaught] = useState();
  const [date, setDate] = useState(null);

  const timingCardArray = [
    { title: "Morning", icon: sunIcon1, timing: "6-9 am" },
    { title: "LateMorning", icon: sunIcon2, timing: "9-12 am" },
    { title: "Afternoon", icon: sunIcon3, timing: "12-3 pm" },
    { title: "Late afternoon", icon: sunIcon4, timing: "3-6 pm" },
    { title: "Evening", icon: sunIcon5, timing: "6-9 pm" },
    { title: "Late Evening", icon: sunIcon6, timing: "9-12 pm" },
  ];
  const [timingCard, setTimingCard] = useState(null);

  const coachQualitiesArray = [
    "Friendly to kids",
    "Supportive",
    "Energetic",
    "Discipline",
    "Trustworthy",
    "Knowledgable",
    "Competitive",
    "Motivator",
    "Good Communicator",
    "Patient",
    "Passionate",
    "Skillful",
    "Caring",
    "Good Listener",
    "Proactive",
  ];

  const skillsTaughtArray = [
    "Forehand",
    "Drop Shot",
    "Approach Shot",
    "Backhand",
    "Lob",
    "Backhand Smash",
    "Top Spin",
    "Backswing",
    "Serve",
    "Underspin",
    "Big Serve",
    "Volley",
    "Stance",
    "Block",
  ];

  const cards = [
    { title: "Tennis", icon: TennisSport },
    { title: "Soccer", icon: SoccerSport },
    { title: "Baseball", icon: BaseballSport },
    { title: "Skating", icon: SkatingSport },
    { title: "Football", icon: FootballSport },
    { title: "Basketball", icon: BasketballSport },
    { title: "Golf", icon: GolfSport },
  ];

  const addProgressWidth = () => {
    setProgressBar(progressBar + 16.66);
  };

  function PageSection1() {
    return (
      <div className={classes.section1}>
        <Container fluid className={classes.container}>
          <Row className={"g-0"}>
            <Col md={12}>
              <h2
                style={{
                  color: Colors.neutralShadesOfNero,
                  ...Fonts.h2,
                  fontSize: "26px",
                  lineHeight: "32px",
                }}
                className={`${[classes.mb16, classes.heading].join(" ")}`}
              >
                Let’s find the right coach for you
              </h2>
              <p
                style={{
                  color: Colors.neutralShadesOfDimGray,
                  ...Fonts.b1Mobile,
                }}
                className={`${[classes.mb24, classes.tagline].join(" ")}`}
              >
                What kind of sport are you interested in?
              </p>
            </Col>
            <Col md={12}>
              <div className={`${[classes.cardsContainer].join(" ")}`}>
                {cards?.map((item) => {
                  return (
                    <div className={`${[classes.card].join(" ")}`}>
                      <PlayCard
                        title={item.title}
                        icon={item?.icon}
                        iconStyle={{
                          width: "80px",
                          height: "80px",
                          //   marginBottom: !isMobile && "16px",
                        }}
                        customStyle={{
                          alignItems: "center",
                          justifyContent: "unset",
                          flexDirection: "row",
                        }}
                        titleStyle={{
                          marginLeft: "24px",
                          ...Fonts.h5,
                          fontWeight: 400,
                          padding: "4px 12px 10px 12px",
                          width: "auto",
                        }}
                        value={""}
                        selectedData={selectedValue}
                        onClick={() => setSelectedValue(item?.title)}
                        showSelection={true}
                      />
                    </div>
                  );
                })}
              </div>
            </Col>
          </Row>
        </Container>
        {/* Footer Btn */}
        <div
          className={classes.footerBtn}
          style={{ borderTop: `1px solid ${Colors.neutralShadesOfGainsboro}` }}
        >
          <Button
            size={"Large"}
            primary={true}
            label={"Next"}
            onClick={() => {
              setPageCount(2);
              addProgressWidth();
            }}
            disabled={selectedValue == null && true}
          />
        </div>
      </div>
    );
  }
  function PageSection2() {
    return (
      <div className={classes.section2}>
        <Container fluid className={classes.container}>
          <Row className={"g-0"}>
            <Col md={12}>
              <h2
                style={{
                  color: Colors.neutralShadesOfNero,
                  ...Fonts.h2,
                  fontSize: "26px",
                  lineHeight: "32px",
                }}
                className={`${[classes.mb16, classes.heading].join(" ")}`}
              >
                What time works best for you
              </h2>
              <p
                style={{
                  color: Colors.neutralShadesOfDimGray,
                  ...Fonts.b1Mobile,
                }}
                className={`${[classes.mb24, classes.tagline].join(" ")}`}
              >
                Choose the most convenient times for you.
              </p>
            </Col>

            <Col md={12}>
              <Row className="gx-2">
                {timingCardArray?.map((item, index) => {
                  return (
                    <Col
                      md={4}
                      sm={4}
                      xs={4}
                      className={index < 3 && classes.mb24}
                    >
                      <div
                        className={`${classes.dayRoutine_container}`}
                        onClick={() => setTimingCard(item)}
                      >
                        <div
                          style={{
                            borderBottom: `2px solid ${timingCard?.title === item?.title
                              ? Colors.mainBlue
                              : Colors.neutralShadesOfWhisper
                              }`,
                            paddingBottom: "8px",
                          }}
                        >
                          <div
                            className={`${classes.dayRoutine_inner_container}`}
                            style={{
                              background:
                                timingCard?.title === item?.title &&
                                Colors.mainShadeOfSolitude,
                            }}
                          >
                            <div
                              className={`${classes.dayRoutine_image_container}`}
                            >
                              <img src={item?.icon} />
                            </div>
                          </div>
                          <h6
                            style={{
                              color: Colors.neutralShadesOfNero,
                              ...Fonts.h7,
                              lineHeight: "24px",
                              fontFamily: "inter-600",
                              marginBottom: "4px",
                            }}
                          >
                            {item?.timing}
                          </h6>
                          <p
                            style={{
                              color: Colors.neutralShadesOfDimGray,
                              ...Fonts.p1,
                              fontSize: "14px",
                            }}
                          >
                            {item?.title}
                          </p>
                        </div>
                      </div>
                    </Col>
                  );
                })}
              </Row>
            </Col>
          </Row>
        </Container>
        {/* Footer Btn */}
        <div
          className={classes.footerBtn}
          style={{ borderTop: `1px solid ${Colors.neutralShadesOfGainsboro}` }}
        >
          <LinkButtonWithIcon
            text={"Go Back"}
            primary={false}
            onClick={() => setPageCount(1)}
          />
          <Button
            size={"Large"}
            primary={true}
            label={"Next"}
            customStyle={{ padding: "12px 57.75px", width: "max-content" }}
            onClick={() => {
              setPageCount(3);
              addProgressWidth();
            }}
            disabled={timingCard == null && true}
          />
        </div>
      </div>
    );
  }
  function PageSection3() {
    return (
      <div className={classes.section3}>
        <Container fluid className={classes.container}>
          <Row className={"g-0"}>
            <Col md={12}>
              <h2
                style={{
                  color: Colors.neutralShadesOfNero,
                  ...Fonts.h2,
                  fontSize: "26px",
                  lineHeight: "32px",
                }}
                className={`${[classes.mb16, classes.heading].join(" ")}`}
              >
                Date availability
              </h2>
              <p
                style={{
                  color: Colors.neutralShadesOfDimGray,
                  ...Fonts.b1Mobile,
                }}
                className={`${[classes.mb24, classes.tagline].join(" ")}`}
              >
                Choose the most convenient times for you.
              </p>
            </Col>

            <Col md={12}>
              <MonthSmallCalander setValue={setDate} value={date} />
            </Col>
          </Row>
        </Container>
        {/* Footer Btn */}
        <div
          className={classes.footerBtn}
          style={{ borderTop: `1px solid ${Colors.neutralShadesOfGainsboro}` }}
        >
          <LinkButtonWithIcon
            text={"Go Back"}
            primary={false}
            onClick={() => setPageCount(2)}
          />
          <Button
            size={"Large"}
            primary={true}
            label={"Next"}
            customStyle={{ padding: "12px 57.75px", width: "max-content" }}
            onClick={() => {
              setPageCount(4);
              addProgressWidth();
            }}
            disabled={date == null && true}
          />
        </div>
      </div>
    );
  }
  function PageSection4() {
    // Step 4 states
    const [coordinate, setCoordinate] = useState({

    });
    const [locationDetail, setLocationDetail] = useState({});
    const [address, setAddress] = useState("");
    const [radius, setRadius] = useState(null);

    return (
      <div className={classes.section4}>
        <Container fluid className={classes.container}>
          <Row className={"g-0"}>
            <Col md={12}>
              <h2
                style={{
                  color: Colors.neutralShadesOfNero,
                  ...Fonts.h2,
                  fontSize: "26px",
                  lineHeight: "32px",
                }}
                className={`${[classes.mb16, classes.heading].join(" ")}`}
              >
                Location
              </h2>
              <p
                style={{
                  color: Colors.neutralShadesOfDimGray,
                  ...Fonts.b1Mobile,
                }}
                className={`${[classes.mb24, classes.tagline].join(" ")}`}
              >
                Where would you want to take your lessons.
              </p>
            </Col>

            <Col md={12} className={classes.mt24}>
              <Maps
                type={"places"}
                label={"Enter your address"}
                setAddress={setAddress}
                placeholder={"Type here.."}
                setCoordinates={setCoordinate}
                setPlaceDetail={setLocationDetail}
              />
            </Col>
            <Col md={12} className={classes.mt24}>
              <DropDown
                state={radius}
                setter={setRadius}
                options={[
                  {
                    label: "10 miles radius",
                    value: "10 miles radius",
                  },
                  {
                    label: "20 miles radius",
                    value: "20 miles radius",
                  },
                  {
                    label: "30 miles radius",
                    value: "30 miles radius",
                  },
                  {
                    label: "40 miles radius",
                    value: "40 miles radius",
                  },
                  {
                    label: "50+ miles radius",
                    value: "50+ miles radius",
                  },
                ]}
              />
            </Col>
            <Col md={12} className={classes.mt24}>
              <div className={classes.map}>
                <Maps type={"map"} location={
                  { lat: 32.715736, lng: -117.161087 }
                } />
              </div>
            </Col>
          </Row>
        </Container>
        {/* Footer Btn */}
        <div
          className={classes.footerBtn}
          style={{ borderTop: `1px solid ${Colors.neutralShadesOfGainsboro}` }}
        >
          <LinkButtonWithIcon
            text={"Go Back"}
            primary={false}
            onClick={() => setPageCount(3)}
          />
          <Button
            size={"Large"}
            primary={true}
            label={"Next"}
            customStyle={{ padding: "12px 57.75px", width: "max-content" }}
            onClick={() => {
              setPageCount(5);
              addProgressWidth();
            }}
            disabled={(address == "" || radius == null) && true}
          />
        </div>
      </div>
    );
  }
  function PageSection5() {
    return (
      <div className={classes.section5}>
        <Container fluid className={classes.container}>
          <Row className={"g-0"}>
            <Col md={12}>
              <h2
                style={{
                  color: Colors.neutralShadesOfNero,
                  ...Fonts.h2,
                  fontSize: "26px",
                  lineHeight: "32px",
                }}
                className={`${[classes.mb16, classes.heading].join(" ")}`}
              >
                Coach qualities
              </h2>
            </Col>

            <Col
              md={12}
              className={`${[classes.mt24, classes.pb24].join(" ")}`}
              style={{
                borderBottom: `1px solid ${Colors.neutralShadesOfWhisper}`,
              }}
            >
              <Checkbox
                label="Unselect all"
                value={unSelectCoachQualities}
                disabled={coachQualities?.length > 1 ? false : true}
                setValue={(e) => {
                  setUnSelectCoachQualities(e);
                  setCoachQualities([]);
                }}
                type={"unselect"}
              />
            </Col>
            <Col md={12} className={classes.mt24}>
              <ul>
                {coachQualitiesArray?.map((item) => {
                  return (
                    <li>
                      <Checkbox
                        label={item}
                        setValue={(e) => {
                          setCoachQualities(e);
                          if (e.length > 1) {
                            setUnSelectCoachQualities(["Unselect all"]);
                          }
                        }}
                        value={coachQualities}
                      />
                    </li>
                  );
                })}
              </ul>
            </Col>
          </Row>
        </Container>
        {/* Footer Btn */}
        <div
          className={classes.footerBtn}
          style={{ borderTop: `1px solid ${Colors.neutralShadesOfGainsboro}` }}
        >
          <LinkButtonWithIcon
            text={"Go Back"}
            primary={false}
            onClick={() => setPageCount(4)}
          />
          <Button
            size={"Large"}
            primary={true}
            label={"Next"}
            customStyle={{ padding: "12px 57.75px", width: "max-content" }}
            onClick={() => {
              setPageCount(6);
              addProgressWidth();
            }}
            disabled={coachQualities?.length < 1 && true}
          />
        </div>
      </div>
    );
  }
  function PageSection6() {
    return (
      <div className={classes.section6}>
        <Container fluid className={classes.container}>
          <Row className={"g-0"}>
            <Col md={12}>
              <h2
                style={{
                  color: Colors.neutralShadesOfNero,
                  ...Fonts.h2,
                  fontSize: "26px",
                  lineHeight: "32px",
                }}
                className={`${[classes.mb16, classes.heading].join(" ")}`}
              >
                Skill taught
              </h2>
            </Col>

            <Col
              md={12}
              className={`${[classes.mt24, classes.pb24].join(" ")}`}
              style={{
                borderBottom: `1px solid ${Colors.neutralShadesOfWhisper}`,
              }}
            >
              <Checkbox
                label="Unselect all"
                value={unSelectSkillsTaught}
                disabled={skillsTaught?.length > 1 ? false : true}
                setValue={(e) => {
                  setUnSelectSkillsTaught(e);
                  setSkillsTaught([]);
                }}
                type={"unselect"}
              />
            </Col>
            <Col md={12} className={classes.mt24}>
              <ul>
                {skillsTaughtArray?.map((item) => {
                  return (
                    <li>
                      <Checkbox
                        label={item}
                        setValue={(e) => {
                          setSkillsTaught(e);
                          if (e.length > 1) {
                            setUnSelectSkillsTaught(["Unselect all"]);
                          }
                        }}
                        value={skillsTaught}
                      />
                    </li>
                  );
                })}
              </ul>
            </Col>
          </Row>
        </Container>
        {/* Footer Btn */}
        <div
          className={classes.footerBtn}
          style={{ borderTop: `1px solid ${Colors.neutralShadesOfGainsboro}` }}
        >
          <LinkButtonWithIcon
            text={"Go Back"}
            primary={false}
            onClick={() => setPageCount(5)}
          />
          <Button
            size={"Large"}
            primary={true}
            label={"Next"}
            customStyle={{ padding: "12px 57.75px", width: "max-content" }}
            onClick={() => setPageCount(6)}
            disabled={skillsTaught?.length < 1 && true}
          />
        </div>
      </div>
    );
  }

  return (
    <div className={classes.page}>
      <div className={classes.header} style={{ background: Colors.white }}>
        <div className={classes.logoAndIcon}>
          <ReactSVG
            src={LogoShortColor}
            beforeInjection={(svg) => svg.classList.add(classes.logo)}
          />
          <div className={classes.linkWithCancelIcon}>
            <LinkButtonWithIcon
              text={"See results"}
              primary={true}
              rightIcon={ArrowUpRightBlue}
              onClick={() => history.push("search-results")}
              customStyle={{ marginRight: "24px" }}
            />
            <ReactSVG
              src={CancelIconBlack}
              beforeInjection={(svg) => svg.classList.add(classes.cancelIcon)}
            />
          </div>
        </div>
        <div
          className={[classes.progressMainDiv]}
          style={{ background: `${Colors.mainShadeOfSolitude}` }}
        >
          <div
            className={[classes.progressInnerDiv]}
            style={{
              background: `${Colors.mainBlue}`,
              width: `${progressBar}%`,
            }}
          />
        </div>
      </div>
      {/* Page Section */}
      <div>
        <p
          style={{
            color: Colors.neutralShadesOfDimGray,
            ...Fonts.b1Mobile,
          }}
          className={`${classes.count} ${classes.mb8}`}
        >
          {pageCount} Out of 6
        </p>

        {pageCount == 1 && <PageSection1 />}
        {pageCount == 2 && <PageSection2 />}
        {pageCount == 3 && <PageSection3 />}
        {pageCount == 4 && <PageSection4 />}
        {pageCount == 5 && <PageSection5 />}
        {pageCount == 6 && <PageSection6 />}
      </div>
    </div>
  );
}

export default GetAMatchMobile;
